import Flicking from '@egjs/react-flicking'
import { useEffectOnce } from 'react-use'

const hasWindowWidth = () => window.innerWidth > 0

/**
 * iOS 최신 버전에서 웹뷰의 초기 창너비가 0일때가 있어 UI 깨짐 있을 수 있음
 * @see {@link https://oss.navercorp.com/place/local/issues/15737}
 *  */
const useInitFlickingWhenWindowHasWidth = (flickingRef: React.RefObject<Flicking>) => {
  useEffectOnce(() => {
    if (hasWindowWidth()) {
      flickingRef.current?.init()
      return () => {}
    }

    const initWhenWindowHasWidth = () => {
      if (hasWindowWidth() && !flickingRef.current?.initialized) flickingRef.current?.init()
    }

    window.addEventListener('resize', initWhenWindowHasWidth)
    return () => window.removeEventListener('resize', initWhenWindowHasWidth)
  })
}

export default useInitFlickingWhenWindowHasWidth
